/*
GET /account/balance
GET /account/transfers
*/

// Path: src/services/AccountService.js
import axios from 'axios';

export default {

  getBalance() {
    return axios.get('api/account/balance')
  },

  getTransfers() {
    return axios.get('api/account/transfers')
  }

}